import {render} from '../lib/lit-html.js';
import {searchPage} from '../templates/searchpage.js';
import {Thumb} from '../lib/mwc-slider-range.js';
import {debounce} from '../utils/debounce.js';

/**
 * Checks if the values in two arrays are different.
 * @param {Array} a - The first array of values.
 * @param {Array} b - The second array of values.
 * @return {Boolean} Is true when the arrays do not contain the same values in 
 * the same order.
 */
function isDifferent(a, b){
	if (a.length !== b.length) return true;
	return b.some((v, i) => v !== a[i]);
	return false;
}

const updateProductImageStickers = (() => {
	let items = [];

	return debounce(state => {
		if (!window.ekmProductImageBadges) return;

		const ids = state.search.items.map(v => v.id);

		if (!isDifferent(ids, items)){
			return;
		}
		
		items = ids;

		if (!ekmProductImageBadges.hasInitialised()){
			ekmProductImageBadges.init();
			return;
		}

		ekmProductImageBadges.reInit();
	}, 900);
})();

export class SearchPageView {
	constructor(store, element){
		this._store = store;
		this._element = element;

		store.subscribe(this._onStateChange.bind(this));

		this._element.addEventListener('click', this._onPaginationButtonClick.bind(this));
		this._element.addEventListener('click', this._onPaginationLoadMoreButtonClick.bind(this));
		this._element.addEventListener('change', this._onCategoryChange.bind(this));
		this._element.addEventListener('change', this._onAttributeChange.bind(this));
		this._element.addEventListener('change', this._onPriceRangeChange.bind(this));
		this._element.addEventListener('input', this._onPriceRangeChange.bind(this));
		this._element.addEventListener('click', this._onToggleFilterClick.bind(this));
		this._element.addEventListener('click', this._onCleanFilterClick.bind(this));
		this._element.addEventListener('click', this._onToggleViewStyleClick.bind(this));
		this._element.addEventListener('click', this._onSimilarButtonClick.bind(this));
		this._element.addEventListener('click', this._onToggleAttributeCollapse.bind(this));
	}

	_onStateChange(state){
		render(searchPage(state), this._element);
		updateProductImageStickers(state);
	}

	_onSimilarButtonClick(event){
		if (!event.target.classList.contains('ekm-search-page-similar-item')) return;
	
		var value = event.target.dataset.query;

		this._store.dispatch({
			type: 'INPUT_VALUE_CHANGE',
			value,
		});

		this._store.dispatch({
			type: 'SEARCH',
		});
	}

	_onPaginationButtonClick(event){
		if (!event.target.classList.contains('ekm-search-page-pagination-button')) return;

		var page = parseFloat(event.target.dataset.page);
		this._store.dispatch({
			type: 'SELECT_PAGE',
			page
		});
	}

	_onPaginationLoadMoreButtonClick(event){
		if (!event.target.classList.contains('ekm-search-page-pagination-loadmore-button')) return;

		this._store.dispatch({
			type: 'LOAD_MORE'
		});
	}

	_onCategoryChange(event){
		if (!event.target.classList.contains('ekm-search-category-select')) return;

		var categories = []

		if (event.target.value) categories.push(event.target.value);

		this._store.dispatch({
			type: 'CHANGE_CATEGORY_FILTER',
			categories
		});
	}

	_onAttributeChange(event){
		if (!event.target.name.startsWith('ekm-search-attr[')) return;

		var name = event.target.name.slice(16, -1);
		var value = event.target.value;

		if (event.target.checked){
			this._store.dispatch({
				type: 'ADD_ATTRIBUTE_FILTER',
				name,
				value
			});
			return;
		}

		this._store.dispatch({
			type: 'REMOVE_ATTRIBUTE_FILTER',
			name,
			value
		});
	}

	_onPriceRangeChange(event){
		var selector = '.ekm-search-page-price-range mwc-slider-range'

		if (!event.target.matches(selector)) return;

		var exponent = this._store.getState().currency.exponent;

		var value = parseFloat(event.detail.value) / 10 ** exponent;

		if (Number.isNaN(value)) console.log(event);

		var final = event.type === 'change';

		if (event.detail.thumb === Thumb.START){
			this._store.dispatch({
				type: "UPDATE_PRICE_RANGE_MIN",
				final,
				value
			});
			return;
		}

		this._store.dispatch({
			type: "UPDATE_PRICE_RANGE_MAX",
			final,
			value
		});
	}

	_onToggleFilterClick(event){
		var selector = '.ekm-search-page-toggle-filter-btn'

		if (!event.target.closest(selector)) return;

		this._store.dispatch({
			type: "TOGGLE_FILTER_VISIBLE"
		});
	}	

	_onCleanFilterClick(event){
		var selector = '.ekm-search-page-attributes-clear-all';

		if (!event.target.closest(selector)) return;

		this._store.dispatch({
			type: 'CLEAR_FILTER'
		});
	}

	_onToggleViewStyleClick(event){
		const selector = '.ekm-search-page-toggle-view-style-btn';

		if (!event.target.closest(selector)) return;

		this._store.dispatch({
			type: 'TOGGLE_VIEW_STYLE',
		});
	}

	_onToggleAttributeCollapse(event){
		const selector = '.ekm-search-page-attribute-toggle';
		const closest = event.target.closest(selector)

		if (!closest) return;

		this._store.dispatch({
			type: 'TOGGLE_ATTRIBUTE_COLLAPSE',
			name: closest.getAttribute('data-key'),
		});
	}
}